module.exports = __webpack_public_path__ + "static/media/user.984bce18.png";